import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useMouseScrubVideo } from './useMouseScrubVideo';
import { useCopy } from './copy/copyMode';
import { WaitlistCTA } from './WaitlistCTA';
export function ClosingCTA() {
  const copy = useCopy();
  const videoRef = useMouseScrubVideo<HTMLVideoElement>();
  return <section className="relative w-full overflow-hidden bg-[#2B211A] min-h-[500px] lg:min-h-[640px] flex items-center py-20 lg:py-0" data-id="element-578">
      {/* Background Video */}
      <video ref={videoRef} src="https://cdn.magicpatterns.com/uploads/226dFRdfRggvPfxj1xsAg2/hf_20260615_142214_5f07e2c1-46e7-4a2e-8268-edfd7124ea28.mp4" muted playsInline preload="auto" className="absolute inset-0 w-full h-full object-cover object-[75%_center] md:object-center" data-id="element-579" />

      {/* Subtle overlay to ensure text readability and blend edges */}
      <div className="absolute inset-0 bg-black/20 pointer-events-none" data-id="element-580" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#2B211A]/80 via-transparent to-transparent pointer-events-none" data-id="element-581" />

      <div className="max-w-[1280px] mx-auto px-6 md:px-10 relative z-10 w-full" data-id="element-582">
        <div className="lg:w-1/2 lg:pr-12 flex flex-col items-center text-center lg:items-start lg:text-left" data-id="element-583">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7
        }} className="font-title font-medium text-4xl md:text-6xl lg:text-7xl tracking-tight text-white leading-[1.05]" data-id="element-584">
            {copy.closingCta.headline}
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: 0.1
        }} className="mt-5 md:mt-7 text-base md:text-xl text-white/80 max-w-lg leading-relaxed" data-id="element-585">
            Join thousands of teams who run their day from Slack or Teams. 7
            days free. Set up in 2 minutes. Get hours back every week.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.7,
          delay: 0.2
        }} className="mt-7 md:mt-9 flex flex-col items-center lg:items-start gap-4" data-id="element-586">
            <WaitlistCTA className="bg-[#EA580C] hover:bg-[#C2410C] text-white px-9 py-4 rounded-full font-bold text-lg transition-colors shadow-[0_0_30px_rgba(234,88,12,0.4)]" data-id="element-587">
              Try Giga for free
            </WaitlistCTA>
            <p className="text-sm text-white/80 font-medium" data-id="element-588">
              7-day free trial · Cancel anytime
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}